/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Nousage1Inputs */

const zh_usage_nousage1 = /** @type {(inputs: Usage_Nousage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无用量记录`)
};

const en_usage_nousage1 = /** @type {(inputs: Usage_Nousage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No usage yet`)
};

const es_usage_nousage1 = /** @type {(inputs: Usage_Nousage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin uso todavía`)
};

/**
* | output |
* | --- |
* | "No usage yet" |
*
* @param {Usage_Nousage1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_nousage1 = /** @type {((inputs?: Usage_Nousage1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Nousage1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_nousage1(inputs)
	if (locale === "en") return en_usage_nousage1(inputs)
	return es_usage_nousage1(inputs)
});
export { usage_nousage1 as "usage_noUsage" }